// PauseManage.js

export let isExamPausedTimerShow = false;

export  function setExamPausedTimerShow(paused) {
  isExamPausedTimerShow = paused;
}

export const PauseManage = {
  setExamPausedTimerShow,
  isExamPausedTimerShow
  
};
